import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import { AddCommaNumber, CleanPrice } from "../../helpers/Utils";

/**
 * Input cho giá tiền — tự format hiển thị dấu chấm ngăn hàng nghìn (VD: 50.000)
 * nhưng chỉ gửi ra rawNumber (VD: "50000") qua onChange.
 *
 * Props:
 *  - value: giá trị thô (string/number, VD: "50000", 50000, "50000.00")
 *  - onChange(rawValue, fieldName): gọi khi blur nếu giá trị thay đổi
 *  - name: tên field (truyền vào onChange param thứ 2)
 *  - Mọi prop khác forward sang <Input>
 */
const PriceInput = ({
  value,
  onChange,
  name,
  placeholder = "0",
  ...rest
}) => {
  const [displayValue, setDisplayValue] = useState(
    value ? AddCommaNumber(value) : ""
  );

  useEffect(() => {
    setDisplayValue(value ? AddCommaNumber(value) : "");
  }, [value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Xóa dấu chấm để lấy số thô
    const rawNumber = inputValue.replace(/\./g, "");
    // Chỉ chấp nhận số nguyên dương (hoặc rỗng)
    if (rawNumber === "" || /^\d+$/.test(rawNumber)) {
      setDisplayValue(rawNumber ? AddCommaNumber(rawNumber) : "");
    }
  };

  const handleBlur = () => {
    const rawNumber = displayValue.replace(/\./g, "") || "0";
    if (rawNumber !== CleanPrice(value)) {
      if (onChange) onChange(rawNumber, name);
    }
  };

  return (
    <Input
      type="text"
      name={name}
      placeholder={placeholder}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      style={{ textAlign: "right" }}
      {...rest}
    />
  );
};

export default PriceInput;
